import React, { PureComponent } from 'react';
import AuthorizeCodeTemplate from '../../../../reset-password/integrations/imported-id/authorize-code/AuthorizeCode.template';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ErrorMessage, Field, Form } from 'formik';

export class VerifyCodeComponent extends PureComponent {
	render() {
		const { isSubmitting, isValid, errors, touched, intl } = this.props;

		return (
			<div className="integration">
				<Form>
					<div
						className={classnames('field', {
							invalid: errors.identifier && touched.identifier,
						})}
					>
						<Field
							name="identifier"
							render={({ field }) => (
								<input
									{...field}
									type="text"
									autoComplete="username"
									placeholder={intl.formatMessage({
										id: 'auth.reset-password.integration.imported-id.field.identifier.placeholder',
									})}
									disabled={isSubmitting}
								/>
							)}
						/>
						<ErrorMessage
							name="identifier"
							render={error => (
								<div className="error">
									<FormattedMessage id={`auth.form.error.${error}`} />
								</div>
							)}
						/>
					</div>
					<AuthorizeCodeTemplate {...this.props} />
					<button
						className={classnames('btn__basic btn__basic--fullWidth', {
							'btn__basic--disabled': !isValid,
							loading: isSubmitting,
						})}
						type="submit"
					>
						<FormattedMessage id="auth.reset-password.integration.imported-id.button" />
					</button>
				</Form>
			</div>
		);
	}
}

export default VerifyCodeComponent;
